import Vue from "vue"
import Vapi from "vuex-rest-api"

const people = new Vapi({
  axios: Vue.axios,
  queryParams: true,
  state: {
    person: null,
    people: [],
    allPeople: [],
    personCategory: null,
    personCategories: [],
    allPersonCategories: [],
    personRole: null,
    personRoles: [],
    allPersonRoles: [],
    band: null,
    bands: [],
    allBands: [],
    transportCompany: null,
    transportCompanies: [],
    allTransportCompanies: [],
  },
})

  // people
  .get({
    action: "retrievePerson",
    property: "person",
    path: ({ id }) => `/people/${id}/`,
  })
  .get({
    action: "listPeople",
    property: "people",
    path: "/people/",
  })
  .get({
    action: "listAllPeople",
    property: "allPeople",
    path: "/people/?no_page=1&fields=id,name,first_name,last_name",
  })
  .post({
    action: "createPerson",
    property: "person",
    path: "/people/",
  })
  .patch({
    action: "updatePerson",
    property: "person",
    path: ({ id }) => `/people/${id}/`,
  })
  .delete({
    action: "destroyPerson",
    path: ({ id }) => `/people/${id}/`,
  })

  // person categories
  .get({
    action: "retrievePersonCategory",
    property: "personCategory",
    path: ({ id }) => `/person-categories/${id}/`,
  })
  .get({
    action: "listPersonCategories",
    property: "personCategories",
    path: "/person-categories/",
  })
  .get({
    action: "listAllPersonCategories",
    property: "allPersonCategories",
    path: "/person-categories/?no_page=1&fields=id,name",
  })
  .post({
    action: "createPersonCategory",
    property: "personCategory",
    path: "/person-categories/",
  })
  .patch({
    action: "updatePersonCategory",
    property: "personCategory",
    path: ({ id }) => `/person-categories/${id}/`,
  })
  .delete({
    action: "destroyPersonCategory",
    path: ({ id }) => `/person-categories/${id}/`,
  })

  // person roles
  .get({
    action: "retrievePersonRole",
    property: "personRole",
    path: ({ id }) => `/person-roles/${id}/`,
  })
  .get({
    action: "listPersonRoles",
    property: "personRoles",
    path: "/person-roles/",
  })
  .get({
    action: "listAllPersonRoles",
    property: "allPersonRoles",
    path: "/person-roles/?no_page=1&fields=id,name",
  })
  .post({
    action: "createPersonRole",
    property: "personRole",
    path: "/person-roles/",
  })
  .patch({
    action: "updatePersonRole",
    property: "personRole",
    path: ({ id }) => `/person-roles/${id}/`,
  })
  .delete({
    action: "destroyPersonRole",
    path: ({ id }) => `/person-roles/${id}/`,
  })

  // bands
  .get({
    action: "retrieveBand",
    property: "band",
    path: ({ id }) => `/bands/${id}/`,
  })
  .get({
    action: "listBands",
    property: "bands",
    path: "/bands/",
  })
  .get({
    action: "listAllBands",
    property: "allBands",
    path: "/bands/?no_page=1&fields=id,name",
  })
  .post({
    action: "createBand",
    property: "band",
    path: "/bands/",
  })
  .patch({
    action: "updateBand",
    property: "band",
    path: ({ id }) => `/bands/${id}/`,
  })
  .delete({
    action: "destroyBand",
    path: ({ id }) => `/bands/${id}/`,
  })

  // transport companies
  .get({
    action: "retrieveTransportCompany",
    property: "transportCompany",
    path: ({ id }) => `/transport-company/${id}/`,
  })
  .get({
    action: "listTransportCompanies",
    property: "transportCompanies",
    path: "/transport-companies/",
  })
  .get({
    action: "listAllTransportCompanies",
    property: "allTransportCompanies",
    path: "/transport-companies/?no_page=1&fields=id,name",
  })
  .post({
    action: "createTransportCompany",
    property: "transportCompany",
    path: "/transport-companies/",
  })
  .patch({
    action: "updateTransportCompany",
    property: "transportCompany",
    path: ({ id }) => `/transport-companies/${id}/`,
  })
  .delete({
    action: "destroyTransportCompany",
    path: ({ id }) => `/transport-companies/${id}/`,
  })

  // finalize
  .getStore()

people.actions.listAllPersonCategory = people.actions.listAllPersonCategories

export default people
